import axios from "axios"
import baseURL from "../config/api"

export const getSmsLogsBySearch = async (selectedGroupId: number, search: string, page: number, size: number, token: string) => {
    const searchValue = search?.trim()?.toLowerCase();
    if (searchValue === "") {
        return await getFetch(`smsLog/GetSmsLogsPaging/${selectedGroupId},${page},${size}`, token)
    } else {
        return await getFetch(`smsLog/GetSmsLogsPagingSearchByRecipientPhonenumber/${selectedGroupId},${searchValue},${page},${size}`, token)
    }
}

const getFetch = async (url: string, token: string, params = {}) => {
    return await axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}